import type { SoundId } from './sound-player'

export const SPEAK_AUDIO_KEY = 'speak'
export const DEFAULT_VOLUME = 60

const FILENAMES = [
  'ambient.wav',
  'blib.mp3',
  'double.wav',
  'drop.wav',
  'event.mp3',
  'plasma.mp3',
  'pling.wav',
  'plong.mp3',
  'radar.mp3',
  'swusch.mp3',
  'zap.mp3',
] as const

export interface SoundCatalogEntry {
  id: SoundId
  label: string
  url: string
}

export const SOUND_CATALOG: Record<SoundId, SoundCatalogEntry> = FILENAMES.reduce(
  (acc, filename) => {
    const [name] = filename.split('.')
    const label = name.charAt(0).toUpperCase() + name.slice(1)
    acc[name] = { id: name, label, url: `/sounds/${filename}` }
    return acc
  },
  {} as Record<SoundId, SoundCatalogEntry>,
)

export const DEFAULT_AUDIO: SoundId = 'ambient'
export const SAMPLE_TICKERS = ['AAPL', 'MSFT', 'GOOG', 'ROG.SW', 'INTC', 'PRX.AS']

export function listSoundIds(): SoundId[] {
  return Object.keys(SOUND_CATALOG)
}

export function getSoundUrl(id: SoundId): string | undefined {
  return SOUND_CATALOG[id]?.url
}
